import { CSSProperties } from 'react'

const base: CSSProperties = {
  padding: '10px 20px',
  border: '2px solid white',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: 600,
}

export const buttonStyles: Record<string, CSSProperties> = {
  default: {
    ...base,
    backgroundColor: 'white',
    color: '#c0392b',
    cursor: 'pointer',
  },
  loading: {
    ...base,
    backgroundColor: 'transparent',
    color: 'white',
    cursor: 'not-allowed',
    opacity: 0.7,
  },
}
